/* P218 (Neil Bumford, 30 Oct 2026): "About product images" (snippets/bhl-image-note.liquid).
   The note is a native details/summary disclosure; this adds Escape to close it (focus returns to its link when focus
   was inside it), closes it on a click or tap outside, and brings an opened panel fully on screen (short screens and
   zoom). Loaded as a module, so it runs once per page. */
const SELECTOR = 'details.bhl-imgnote[open]';

// toggle does not bubble: listen in the capture phase
document.addEventListener(
  'toggle',
  (event) => {
    const note = event.target;
    if (!(note instanceof HTMLElement) || !note.matches(SELECTOR)) return;
    note.querySelector('.bhl-imgnote__panel')?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  },
  true
);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const note of document.querySelectorAll(SELECTOR)) {
    const focusInside = note.contains(document.activeElement);
    note.open = false;
    if (focusInside) note.querySelector('summary')?.focus();
  }
});

document.addEventListener('click', (event) => {
  const target = event.target instanceof Node ? event.target : null;
  for (const note of document.querySelectorAll(SELECTOR)) {
    if (!target || !note.contains(target)) note.open = false;
  }
});
